<template>
    <div>
        <!--<div>自己的id：{{userId}}</div>-->

        <!--<div>{{message}}</div>-->

        <!--当点击的好友聊天页面和接收服务端中的好友一致时-->
        <div v-if="msgFriendId===friendId">
            <div>聊天信息</div>
            <!--接收的聊天信息-->
            <div><p style="white-space: pre-line">{{message}}</p></div>
            <!--<div>服务器接受自己的id：{{msgUserId}}</div>-->
            <!--<div>服务器接受自己的好友id：{{msgFriendId}}</div>-->
        </div>
        <!--自己发送的信息-->
        <div style="text-align: right"><p style="white-space: pre-line">{{myMessage}}</p></div>

        <!--<div>userId:{{userId}}</div>-->
        <!--<div>friendId:{{friendId}}</div>-->
        <!--<div>msgUserId:{{msgUserId}}</div>-->
        <!--<div>msgFriendId:{{msgFriendId}}</div>-->

        <div style="position: absolute;bottom: 0px;display: inline-flex">
            <el-input v-model="msg" style="width: 400px"></el-input>
            <el-button type="primary" @click="send">发消息</el-button>
        </div>
    </div>
</template>

<script>
    import protoc from "../protoc/DataContent_pb.js"

    export default {
        name: "ChatUser",
        data() {
            return {
                userId: "",
                friendId: '',  //用户好友列表的id
                socket: null,

                msgUserId: "",
                msgFriendId: "",  //接收服务端数据中好友的id

                msg: "",
                message: "",
                myMessage:"",
            }
        },
        watch: {
            /*监听路由变化*/
            $route: {
                handler() {
                    this.friendId = this.$route.params && this.$route.params.friendId;  //用户好友列表的id
                },
                immediate: true
            }
        },
        created() {
            this.userId = this.$store.state.user.userId;

            if (this.userId === "" || this.userId === null){
                this.$message({
                    showClose: true,
                    message: "请先登录",
                    type: 'error'
                });
            } else {
                //获取store上的websocket
                this.socket = this.$store.state.websocket
                //如果websocket在store刷新之后断开连接，则在这里重新连接websocket
                if (this.socket.readyState === WebSocket.CONNECTING) {
                    // 监听socket连接,连接socket时触发
                    this.socket.onopen = this.open
                }
                // 监听socket错误信息，出现错误的时候触发
                this.socket.onerror = this.error
                // 监听socket消息，收到服务器端回送的消息
                this.socket.onmessage = this.getMessage
                this.socket.binaryType = "arraybuffer";
            }
        },
        methods: {
            //连接服务端,注册channel
            open: function () {
                console.log("socket连接成功")
                //构建chatMsgProtoc
                const chatMsgProtoc = this.GLOBAL.chatMsgProtoc(this.userId, null, null, null);
                //构建dataContentProtocBytes,给服务发送信息，定义action=1
                const dataContentProtocBytes = this.GLOBAL.dataContentProtocBytes(1, chatMsgProtoc, null);
                //发送userId，和channel匹配
                this.socket.send(dataContentProtocBytes)
            },
            //获取服务端返回的信息
            getMessage: function (msg) {
                var chatMsgResponse = new protoc.DataContent.ChatMsgContent.deserializeBinary(msg.data)
                this.message += chatMsgResponse.getMsgcontent() + "\n";
                this.msgUserId = chatMsgResponse.getUserid();
                this.msgFriendId = chatMsgResponse.getTalkid();
            },
            //发送信息给服务端
            send: function () {
                //通过socket给服务端发送信息,定义action=2
                //构建chatMsgProtoc
                const chatMsgProtoc = this.GLOBAL.chatMsgProtoc(this.userId, this.friendId, this.msg, null);
                //构建dataContentProtocBytes,给服务发送信息，定义action=1
                const dataContentProtocBytes = this.GLOBAL.dataContentProtocBytes(2, chatMsgProtoc, null);
                //向服务端发送数据，服务端再转发给好友
                this.socket.send(dataContentProtocBytes)
                //自己输入的信息
                this.myMessage += this.msg + "\n"
                //清空输入框数据
                this.msg = ""
            },
            //出现错误的时候
            error: function () {
                console.log("连接错误")
            },
        },
        //断开连接的时候
        destroyed() {
            // 销毁监听，断开socket时触发
            this.socket.onclose = this.close
            console.log("websocket已断开")
        }
    }
</script>

<style scoped>

</style>
